import React, { Component } from 'react';
import Firebase from 'firebase';
import { Route, Link } from 'react-router-dom';
import Select from 'react-select';

const gps_options = [
    { label: "Si", value: "1" },
    { label: "No", value: "0" },
    { label: "Si, solo si esta disponible", value: "2" }
]

export default class formularioItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            full: false,
            button: "fa fa-bars",
            id: props.id,
            gps: props.formulario.GPS,
            published: props.formulario.published
        }
    }


    removeForm() {
        var draftRef = Firebase.database().ref('forms').child(this.props.id).remove().then((resp) => {
            var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
            var regId = Firebase.database().ref().child('log').push().key;
            logRef.child(regId).set({
                admin: localStorage.email,
                timestamp: Firebase.database.ServerValue.TIMESTAMP,
                action: "delete",
                target: {
                    type: "form",
                    id: this.props.id,
                    name: this.props.formulario.name
                }
            });
        });
    }
    componentWillUpdate(nextProps, nextState) {
        var formRef = Firebase.database().ref('forms/' + this.props.id);
        const contex = this;
        if (nextState.full && nextState.button !== this.state.button) {
            setTimeout(function () {
                contex.setState({ button: "fa fa-arrow-left" })
            }, 800);
        }
        else if (!nextState.full && nextState.button !== this.state.button) {
            setTimeout(function () {
                contex.setState({ button: "fa fa-bars" })
            }, 800);
        }
        else if (nextState.gps !== this.state.gps) {
            formRef.child("GPS").set(
                nextState.gps
            )
        }
        else if (nextState.published !== this.state.published) {
            formRef.child("published").set(
                nextState.published
            )
        }
    }

    render() {
        var url;
        if (this.props.formulario.icon) {
            url = 'iconos/' + this.props.formulario.icon + ".svg";
        } else {
            url = 'iconos/test.svg';
        }
        return (
            <div className="form-group row" style={{ border: "1px solid #CCC", borderRadius: "5px", height: "210px", boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)" }}>
                <div className="col-md-4" style={{ background: "url(img/background_form.png)", borderBottomLeftRadius: "3px", borderTopLeftRadius: "3px" }}>
                    <Link to={"/editor/" + this.props.id}>
                        <img className="img-responsive" src={url} style={{ position: "relative", top: "20px", width :"80%" }} />
                    </Link>
                    <Link to={"/editor/" + this.props.id}>
                        <b style={{ position: "absolute", bottom: "10px", left: "20px", color: "#FFF", fontSize: "18px" }} >Formulario</b>
                    </Link>
                </div>
                <div className="col-md-8">
                    <h2 style={{ top: "15px", position: "relative" }}>{this.props.formulario.name}</h2>
                    <div>
                        <div className="form">
                            <small><b>GPS habilitado</b></small>
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-searchable has-value"
                                value={this.state.gps}
                                options={gps_options}
                                onChange={(e) => {
                                    this.setState({ gps: e.value })
                                }}
                            />
                        </div>
                        <div className="form">
                            <div className="clearfix mt-4">
                                <small><b>Formulario habilitado</b></small>
                                <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                    <input type="checkbox" className="switch-input" checked={this.state.published} onClick={() => { this.setState({ published: !this.state.published }) }} />
                                    <span className="switch-label" data-on="On" data-off="Off"></span>
                                    <span className="switch-handle"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div style={{ position: "absolute", bottom: "3", right: "2" }}>
                        <button type="button" className="btn btn-outline-success" style={{ cursor: "pointer" }} onClick={() => { var l = document.getElementById("view" + this.props.id); l.click(); }}>
                            Visualizar <a className="fa fa-fw fa fa-eye" ></a>
                        </button>
                        <button type="button" className="btn btn-outline-danger" style={{ cursor: "pointer" }} onClick={(e) => { this.removeForm() }}>
                            Eliminar <a className="fa fa-fw fa fa-times"></a>
                        </button>
                        <Link id={"edit" + this.props.id} to={"/editor/" + this.state.id} style={{ display: "none" }} />
                        <Link id={"view" + this.props.id} to={"/vista/" + this.state.id} style={{ display: "none" }} />
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/views/forms/formularioItem.js